import { useTranslation } from 'react-i18next';
import { PaperclipIcon, TrashIcon } from '@utils/icons';
import type { IPendingAttachment } from '../../../hooks/useComposerAttachments';
import styles from './PendingAttachments.module.css';

interface IPendingAttachmentsProps {
  items: IPendingAttachment[];
  onRemove: (localId: string) => void;
}

export function PendingAttachments({ items, onRemove }: IPendingAttachmentsProps) {
  const { t } = useTranslation();
  if (items.length === 0) return null;
  return (
    <ul className={styles.pendingList}>
      {items.map((item) => (
        <li key={item.localId} className={styles.pendingItem}>
          {item.kind === 'image' && item.previewUrl && (
            <img src={item.previewUrl} alt={item.name} className={styles.pendingThumb} />
          )}
          {item.kind === 'file' && (
            <span className={styles.pendingFileLabel}>
              <PaperclipIcon size={14} />
              <span className={styles.pendingFileName}>{item.name}</span>
            </span>
          )}
          <button
            type="button"
            className={styles.pendingRemoveBtn}
            onClick={() => onRemove(item.localId)}
            aria-label={t('comms.composer.removeAttachment')}
          >
            <TrashIcon size={12} />
          </button>
        </li>
      ))}
    </ul>
  );
}
